import React, { useState } from 'react';
import '../css/AssessmentForm.css';
import { useNavigate } from 'react-router-dom'; 
function Submitting({isSubmitted}) {
    const navigate = useNavigate();
    const goHome = () => {
        navigate('/candidate-home');
    }
    return (
        <div className="submitting-assessment">
        <h2>{isSubmitted}</h2>
        {isSubmitted ? <h2>Submitted successfully</h2> : <h2>Submitting</h2>}
        {isSubmitted && <button onClick={goHome}>Home</button>}
        </div>
    );
                      
}

export default Submitting;